import { render, staticRenderFns } from "./join-done.vue?vue&type=template&id=78d10945&scoped=true&lang=pug"
import script from "./join-done.vue?vue&type=script&lang=js"
export * from "./join-done.vue?vue&type=script&lang=js"
import style0 from "../access.scss?vue&type=style&index=0&id=78d10945&prod&lang=scss&scoped=true&external"
import style1 from "./join-done.vue?vue&type=style&index=1&id=78d10945&prod&lang=scss&scoped=true"
import style2 from "./join-done.vue?vue&type=style&index=2&id=78d10945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d10945",
  null
  
)

export default component.exports